import { readCleanedRedirectCookie } from '~/composables/readCleanedRedirectCookie'
import { useIdentityStore } from '~/store/identity'
import { useRootStore } from '~/store/root'

export function bounceIfAlreadyLoggedIn(to) {
  const rootStore = useRootStore()
  const identityStore = useIdentityStore()
  if (!rootStore.isLoggedIn || identityStore.postLoginIdentityUrls.includes(to.path)) return

  const redirect = readCleanedRedirectCookie()
  useNuxtApp().$lendioCookies.remove('redirect')
  return navigateTo(redirect ?? '/resume-app')
}
